import type { Check } from "../../api/check";
import type { Category, CategoryCreateRequest, CategoryUpdateRequest } from "../../api/category";

export interface CategoryFormValues {
  name: string;
  description: string;
  checkIds: string[];
}

export const emptyCategoryForm = (): CategoryFormValues => ({
  name: "",
  description: "",
  checkIds: [],
});

export const categoryToForm = (category: Category): CategoryFormValues => ({
  name: category.name ?? "",
  description: category.description ?? "",
  checkIds:
    category.checks?.map((check) => check.id).filter((id): id is string => Boolean(id)) ?? [],
});

export const formToCategoryCreate = (form: CategoryFormValues): CategoryCreateRequest => ({
  name: form.name.trim(),
  description: form.description.trim() || undefined,
  checks: form.checkIds,
});

export const formToCategoryUpdate = (
  form: CategoryFormValues,
  id: string
): CategoryUpdateRequest => ({
  id,
  name: form.name.trim(),
  description: form.description.trim() || undefined,
  checks: form.checkIds,
});

export const validateCategoryForm = (form: CategoryFormValues): string | null => {
  if (!form.name.trim()) {
    return "Укажите название категории";
  }

  return null;
};

export const mergeCategoryCheckOptions = (
  allChecks: Check[],
  category: Category | null
): Check[] => {
  const byId = new Map<string, Check>();

  for (const check of allChecks) {
    if (check.id) {
      byId.set(check.id, check);
    }
  }

  for (const check of category?.checks ?? []) {
    if (check.id && !byId.has(check.id)) {
      byId.set(check.id, {
        id: check.id,
        code: check.code,
        description: check.description,
      });
    }
  }

  return [...byId.values()].sort((a, b) => {
    const labelA = a.description?.trim() || a.code?.trim() || a.id || "";
    const labelB = b.description?.trim() || b.code?.trim() || b.id || "";
    return labelA.localeCompare(labelB, "ru");
  });
};
